import styled from 'styled-components';

export const LogIn = styled.div`
    width:100%;
    height:100vh;
    background:#262930;
`;

export const Container = styled.div`
    max-width:1000px;
    margin:auto;
    height:100%;
    display:flex;
    align-items:center;
    justify-content:center;

`;

export const Form = styled.form`
    display:flex;
    padding:20px;
    align-items:center;
    justify-content:center;
    flex-direction:column;
    background:#262930;
`;

export const TextInput = styled.input`
    width:300px;
    height:40px;
    border-radius:5px;
    border:0;
    outline:none;
    margin:5px;
    padding-left:10px;
    background:#383C47;
    color:white;
`;

export const FormImage = styled.img`
    width:100px;
    margin:20px;
`;


export const Button = styled.button`
    width:310px;
    height:35px;
    margin:5px;
    background:#59B8D4;
    color:white;
    border:0;
    border-radius:5px;
    cursor: pointer;

    &:hover{
        background:#38869e;
    }

`;


